import { useEffect, useState } from 'react'
import { LuxAutocomplete, LuxChip, LuxButton, Color } from '@lux/wardrobe-lib'
import { connect } from 'react-redux'
import { FILTERS_REDUCER_NAMESPACE } from '@/app/redux/reducers/filters'
import { getPhotoTagList } from '@/app/redux/actions/filters'
import { useIntl } from 'react-intl'

const PhotoTagsSelect = (props: {
    value: string[]
    onChangeValue: (val) => void
    bannerList: string[]
    tagList: string[]
    getTagList: (banner: string[]) => void
}) => {
    const { value, onChangeValue, getTagList, bannerList, tagList } = props
    const intl = useIntl()
    const [predictions, setPredictions] = useState<string[]>([])
    const [inputValue, setInputValue] = useState('')

    useEffect(() => {
        if (bannerList.length && tagList.length === 0) {
            getTagList(bannerList)
        }
    }, [bannerList.length])

    const handleTagSelect = (tag: string) => {
        let _value = value || []
        onChangeValue([..._value, tag])
        setInputValue('')
    }

    const handleTagDelete = (tag: string) => {
        onChangeValue(value?.filter((t) => t !== tag))
    }

    return (
        <div>
            <LuxAutocomplete
                value={inputValue}
                predictions={predictions?.map((tag) => ({ value: tag, label: tag }))}
                onSearchPredictions={(search) => {
                    let _predictions = search
                        ? tagList?.filter((tag) => tag.toLowerCase().includes(search.toLowerCase()))
                        : []
                    setPredictions(_predictions)
                }}
                onPredictionSelected={(v) => handleTagSelect(v.value)}
                onChangeCallback={setInputValue}
                onClear={() => setInputValue('')}
                additionalProps={{ appendTo: 'self' }}
            />
            <div>
                <div className="flex">
                    {value?.map((tag) => (
                        <div key={tag} className="m-2">
                            {/* {tag}
                            <button onClick={() => handleTagDelete(tag)}>Delete</button> */}

                            <LuxChip removable onRemove={() => handleTagDelete(tag)} label={tag} />
                        </div>
                    ))}
                </div>
                {value?.length > 1 && (
                    <LuxButton
                        text={intl.formatMessage({
                            id: 'ph2.filter.tags.delete_all',
                            defaultMessage: 'Delete all tags',
                        })}
                        variant="text"
                        iconLeft="trash"
                        onClick={() => onChangeValue([])}
                        color={Color.BLUE}
                    />
                )}
            </div>
        </div>
    )
}

const mapStateToProps = (state: any) => ({ tagList: state[FILTERS_REDUCER_NAMESPACE].tags })

const mapDispatchToProps = (dispatch: any) => ({
    getTagList: (banner: string[]) => dispatch(getPhotoTagList(banner)),
})

export default connect(mapStateToProps, mapDispatchToProps)(PhotoTagsSelect)
